module.exports = __webpack_public_path__ + "static/media/magazzino.66a8ff31.webp";